<nav aria-label="Primary navigation" class="usa-nav">
    <div class="usa-nav__inner">
        <button class="usa-nav__close">
            <img src="assets/img/close.svg" alt="close">
        </button>
        <ul class="usa-nav__primary usa-accordion">
            <li class="usa-nav__primary-item">
                <a
                  class="usa-nav__link"
                  routerLink="/dashboard"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: false }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>Dashboard</span></a>
            </li>
            <li class="usa-nav__primary-item">
                <a
                  class="usa-nav__link"
                  routerLink="/fire-tracker"
                  *ngIf="showFiretracker"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>Fire Tracker</span></a>
            </li>
            <li class="usa-nav__primary-item">
                <a
                  class="usa-nav__link"
                  routerLink="/assessments"
                  *ngIf="showAssessments"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>BAER Assessments</span></a>
            </li>
            <li class="usa-nav__primary-item">
                <a
                  class="usa-nav__link"
                  routerLink="/reports"
                  *ngIf="showReports"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>Reports</span></a>
            </li>
            <li class="usa-nav__primary-item">
                <a
                  class="usa-nav__link"
                  routerLink="/roster"
                  *ngIf="showRoster"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>Roster</span></a>
            </li>
            <li class="usa-nav__primary-item" *ngIf="showTestPages">
                <a
                  class="usa-nav__link"
                  routerLink="/data-manipulation"
                  routerLinkActive="usa-current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  #rlaDash="routerLinkActive"
                  [attr.aria-current]="rlaDash.isActive ? 'page' : null"
                ><span>Data Manipulation</span></a>
            </li>
        </ul>
    </div>
</nav>
